import TellersService from './TellersService';

export const tellersService = new TellersService();
